import translate from './index';

const moment = require('moment');

const convertEpochTimeToStandardDate = (dateObject) => {
  return moment(dateObject).format(translate('en', 'timeFormat.ShortDay'));
};
/**
 * Converts the time format to a 12 hour format (e.g., 4:00pm)
 * @param  {object} dateObject can accept `Date` object or moment objects
 * @return {String}
 */
const convertToStandardTime = (dateObject) => {
  return moment(dateObject).format(translate('en', 'timeFormat.Time'));
};

/**
 * Slash format date string (e.g., 11/28/2021)
 * @param  {object} momentObject moment object used for formatting
 * @return {String}              formatted date string in a slash format
 */
const slashDateFormat = (momentObject) => {
  return momentObject.format(translate('en', 'timeFormat.FullDay'));
};

/**
 * Full time with seconds (e.g. 3:23:54pm)
 * @param  {object} dateObject can accept `Date` object or moment objects
 * @return {String}              formatted time string
 */
const fullStandardTime = (dateObject) => {
  return moment(dateObject).format(translate('en', 'timeFormat.FullTime'));
};

/**
 * Full date with day suffix (e.g. March 23rd, 2022)
 * @param  {object} dateObject can accept `Date` object or moment objects
 * @return {String}              formatted date string
 */
const longStandardDate = (dateObject) => {
  return moment(dateObject).format(translate('en', 'timeFormat.LongDay'));
};

/**
 * Full date with day suffix, day of week, and full time (e.g. Monday, March 23rd 2022, 3:23:54pm)
 * @param  {object} dateObject can accept `Date` object or moment objects
 * @return {String}              formatted date string
 */
const verboseDate = (dateObject) => {
  return moment(dateObject).format(translate('en', 'timeFormat.VerboseDay'));
};

/**
 * Short date with time (e.g. Jan 23, 2022 3:23 PM)
 * @param  {object} dateObject can accept `Date` object or moment objects
 * @return {String}              formatted date string
 */
const shortDateTime = (dateObject) => {
  if (!dateObject) {
    return '';
  }

  return moment(dateObject).format(translate('en', 'timeFormat.ShortDateTime'));
};

export {
  convertEpochTimeToStandardDate,
  convertToStandardTime,
  slashDateFormat,
  fullStandardTime,
  longStandardDate,
  verboseDate,
  shortDateTime,
};
